import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
// import * as Icons from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import { TourProvider } from "@reactour/tour";
import { AuthProvider } from "./context/AuthContext";
import Routes from "./routes";
import "./assets/styles/ckEditor.scss";
import SearchBarState from "./components/SearchBar/context/SearchBarState";
import FetcherCacheState from "./context/fetcherCache/FetcherCacheState";
import { steps } from "./pages/NotasDePedidoDetail/steps";
import { TourSteps } from "./components/Tour";
import { customTourStyles } from "./components/Tour/styles";

/* const iconList = Object.keys(Icons)
  .filter((key) => key !== "fas" && key !== "prefix")
  .map((icon) => Icons[icon]);

library.add(...iconList);
*/
library.add(fas, far);

const App = () => (
  <div className="App">
    <Helmet>
      <meta charSet="utf-8" />
      <title>PIN</title>
    </Helmet>
    <ToastContainer />
    <BrowserRouter>
      <AuthProvider>
        <FetcherCacheState>
          <TourProvider steps={steps} styles={customTourStyles} ContentComponent={(props) => <TourSteps {...props} />}>
            <SearchBarState>
              <Switch>
                <Routes />
              </Switch>
            </SearchBarState>
          </TourProvider>
        </FetcherCacheState>
      </AuthProvider>
    </BrowserRouter>
  </div>
);

export default App;
